"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityFinalNegotiationQuoteDocuments = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_final_negotiation_entity_1 = require("./opportunity-final-negotiation.entity");
/**
 * Entity for opportunity_final_negotiation_quote_documents table.
 */
let OpportunityFinalNegotiationQuoteDocuments = class OpportunityFinalNegotiationQuoteDocuments {
};
exports.OpportunityFinalNegotiationQuoteDocuments = OpportunityFinalNegotiationQuoteDocuments;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQuoteDocuments.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_final_negotiation_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQuoteDocuments.prototype, "opportunityFinalNegotiationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "quote_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQuoteDocuments.prototype, "quoteId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQuoteDocuments.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQuoteDocuments.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityFinalNegotiationQuoteDocuments.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityFinalNegotiationQuoteDocuments.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_final_negotiation_entity_1.OpportunityFinalNegotiation, (neg) => neg.quoteDocs, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_final_negotiation_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _c : Object)
], OpportunityFinalNegotiationQuoteDocuments.prototype, "finalNegotiation", void 0);
exports.OpportunityFinalNegotiationQuoteDocuments = OpportunityFinalNegotiationQuoteDocuments = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_final_negotiation_quote_documents")
], OpportunityFinalNegotiationQuoteDocuments);
